import axios from 'axios'

function initialState() {
  return {
    clientId: 'UYE7W5GUQ6yVZAlo',
    clientSecret: 'ac111e2a22954bbba94cc61344466588',
    arcGISAccessToken: '',
    expireDate: null,
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async acquireAccessToken({ commit, state }) {
      return axios.post('/arcGisToken',
        'grant_type=client_credentials&client_id=' + state.clientId + '&client_secret=' + state.clientSecret, {
          'headers': { 'Content-Type': 'application/x-www-form-urlencoded' },
        }, ).then((res) => {
          console.log('ArcGis Access Token', res)
          commit('SET_ACCESS_TOKEN', res.data.access_token)
          commit('SET_EXPIRE_DATE', res.data.expires_in)
        }).catch((error) => {
          console.log(error)
        })
    },
  },

  mutations: {
    SET_ACCESS_TOKEN: (s, payload) => s.arcGISAccessToken = payload,
    SET_EXPIRE_DATE: (s, payload) => {
      if (payload != null) {
        var expireDate = new Date()
        var expireDateInMillisecons = expireDate.getTime()
        expireDate.setTime(expireDateInMillisecons + 1000 * payload)
        s.expireDate = expireDate
      } else {
        s.expireDate = null
      }
    },
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },

  getters: {
    arcGISAccessToken: s => s.arcGISAccessToken,
    isArcGisTokenValid: s => { return s.arcGISAccessToken != null && s.expireDate != null && s.expireDate > new Date() },
  },
}